import React, { Component } from 'react'
import HideFetched from './HideFetched'
import TextField from '../TextField'
import PasswordField from '../PasswordField'
import SelectField from '../SelectField'
import range from 'lodash/range'


const currentYear = new Date().getFullYear()
const genderOptions = [
  {value: "", label: ""},
  {value: "M", label: "Male"},
  {value: "F", label: "Female"}
]
const monthOptions = [
  {value: "1", label: "January"},
  {value: "2", label: "February"},
  {value: "3", label: "March"},
  {value: "4", label: "April"},
  {value: "5", label: "May"},
  {value: "6", label: "June"},
  {value: "7", label: "July"},
  {value: "8", label: "August"},
  {value: "9", label: "September"},
  {value: "10", label: "October"},
  {value: "11", label: "November"},
  {value: "12", label: "December"}
]
const dayOptions = range(1, 32).map(i => i.toString())
const yearOptions = range(currentYear - 18, currentYear - 18 - 100, -1).map(i => i.toString())

export default class EmailRegistrationForm extends Component {
  render() {
    const { firstName, lastName, email, displayName, password, passwordConfirmation, gender, birthmonth, birthday, birthyear } = this.props
    const { onChange, errors, fetchedParams } = this.props

    return (
      <div>
        <div className="row-wrapper">
          <HideFetched name="firstName" fetchedParams={fetchedParams}>
            <div className="left-col">
              <TextField
                label="First Name"
                value={firstName}
                onChange={(val) => onChange("firstName", val)}
                error={errors.firstName}
              />
            </div>
          </HideFetched>

          <HideFetched name="lastName" fetchedParams={fetchedParams}>
            <div className="right-col">
              <TextField
                label="Last Name"
                value={lastName}
                onChange={(val) => onChange("lastName", val)}
                error={errors.lastName}
              />
            </div>
          </HideFetched>
        </div>

        <div className="row-wrapper">
          <HideFetched name="email" fetchedParams={fetchedParams}>
            <div className="left-col">
              <TextField
                label="Email"
                value={email}
                onChange={(val) => onChange("email", val)}
                error={errors.email}
              />
            </div>
          </HideFetched>

          <HideFetched name="displayName" fetchedParams={fetchedParams}>
            <div className="right-col">
              <TextField
                label="Display Name"
                value={displayName}
                onChange={(val) => onChange("displayName", val)}
                error={errors.displayName}
              />
            </div>
          </HideFetched>
        </div>

        <div className="row-wrapper">
          <HideFetched name="password" fetchedParams={fetchedParams}>
            <div className="left-col">
              <PasswordField
                label="Choose Password"
                value={password}
                onChange={(val) => onChange("password", val)}
                error={errors.password}
              />
            </div>
          </HideFetched>

          <HideFetched name="passwordConfirmation" fetchedParams={fetchedParams}>
            <div className="right-col">
              <PasswordField
                label="Confirm Password"
                value={passwordConfirmation}
                onChange={(val) => onChange("passwordConfirmation", val)}
                error={errors.passwordConfirmation}
              />
            </div>
          </HideFetched>
        </div>

        <div className="row-wrapper">
          <HideFetched name="gender" fetchedParams={fetchedParams}>
            <div className="left-col">
              <SelectField
                label="Gender"
                value={gender}
                availableValues={genderOptions}
                onChange={(val) => onChange("gender", val)}
                error={errors.gender}
              />
            </div>
          </HideFetched>

          <HideFetched name={["birthmonth", "birthday", "birthyear"]} fetchedParams={fetchedParams}>
            <div className="birthday-wrapper">
              <div className="form-group">
                <label>Birthday</label>
                <SelectField
                  value={birthmonth}
                  availableValues={monthOptions}
                  onChange={(val) => onChange("birthmonth", val)}
                  error={errors.birthmonth}
                  wrapperClass={null}
                />
              </div>
            </div>
            <div className="birthday-wrapper">
              <div className="form-group">
                <label>&nbsp;</label>
                <SelectField
                  value={birthday}
                  availableValues={dayOptions}
                  onChange={(val) => onChange("birthday", val)}
                  error={errors.birthday}
                  wrapperClass={null}
                />
              </div>
            </div>
            <div className="birthday-wrapper">
              <div className="form-group">
                <label>&nbsp;</label>
                <SelectField
                  value={birthyear}
                  availableValues={yearOptions}
                  onChange={(val) => onChange("birthyear", val)}
                  error={errors.birthyear}
                  wrapperClass={null}
                />
              </div>
            </div>
          </HideFetched>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupWidget/EmailRegistrationForm.js